/**
 * RukuNaSrce API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type HttpStatusCode = 100 | 101 | 102 | 103 | 200 | 201 | 202 | 203 | 204 | 205 | 206 | 207 | 208 | 226 | 300 | 301 | 302 | 303 | 304 | 305 | 306 | 307 | 308 | 400 | 401 | 402 | 403 | 404 | 405 | 406 | 407 | 408 | 409 | 410 | 411 | 412 | 413 | 414 | 415 | 416 | 417 | 421 | 422 | 423 | 424 | 426 | 428 | 429 | 431 | 451 | 500 | 501 | 502 | 503 | 504 | 505 | 506 | 507 | 508 | 510 | 511;

export const HttpStatusCode = {
    Continue: 100 as HttpStatusCode,
    SwitchingProtocols: 101 as HttpStatusCode,
    Processing: 102 as HttpStatusCode,
    EarlyHints: 103 as HttpStatusCode,
    OK: 200 as HttpStatusCode,
    Created: 201 as HttpStatusCode,
    Accepted: 202 as HttpStatusCode,
    NonAuthoritativeInformation: 203 as HttpStatusCode,
    NoContent: 204 as HttpStatusCode,
    ResetContent: 205 as HttpStatusCode,
    PartialContent: 206 as HttpStatusCode,
    MultiStatus: 207 as HttpStatusCode,
    AlreadyReported: 208 as HttpStatusCode,
    IMUsed: 226 as HttpStatusCode,
    MultipleChoices: 300 as HttpStatusCode,
    Ambiguous: 301 as HttpStatusCode,
    MovedPermanently: 302 as HttpStatusCode,
    Moved: 303 as HttpStatusCode,
    Found: 304 as HttpStatusCode,
    Redirect: 305 as HttpStatusCode,
    SeeOther: 306 as HttpStatusCode,
    RedirectMethod: 307 as HttpStatusCode,
    NotModified: 308 as HttpStatusCode,
    UseProxy: 400 as HttpStatusCode,
    Unused: 401 as HttpStatusCode,
    TemporaryRedirect: 402 as HttpStatusCode,
    RedirectKeepVerb: 403 as HttpStatusCode,
    PermanentRedirect: 404 as HttpStatusCode,
    BadRequest: 405 as HttpStatusCode,
    Unauthorized: 406 as HttpStatusCode,
    PaymentRequired: 407 as HttpStatusCode,
    Forbidden: 408 as HttpStatusCode,
    NotFound: 409 as HttpStatusCode,
    MethodNotAllowed: 410 as HttpStatusCode,
    NotAcceptable: 411 as HttpStatusCode,
    ProxyAuthenticationRequired: 412 as HttpStatusCode,
    RequestTimeout: 413 as HttpStatusCode,
    Conflict: 414 as HttpStatusCode,
    Gone: 415 as HttpStatusCode,
    LengthRequired: 416 as HttpStatusCode,
    PreconditionFailed: 417 as HttpStatusCode,
    RequestEntityTooLarge: 421 as HttpStatusCode,
    RequestUriTooLong: 422 as HttpStatusCode,
    UnsupportedMediaType: 423 as HttpStatusCode,
    RequestedRangeNotSatisfiable: 424 as HttpStatusCode,
    ExpectationFailed: 426 as HttpStatusCode,
    MisdirectedRequest: 428 as HttpStatusCode,
    UnprocessableEntity: 429 as HttpStatusCode,
    UnprocessableContent: 431 as HttpStatusCode,
    Locked: 451 as HttpStatusCode,
    FailedDependency: 500 as HttpStatusCode,
    UpgradeRequired: 501 as HttpStatusCode,
    PreconditionRequired: 502 as HttpStatusCode,
    TooManyRequests: 503 as HttpStatusCode,
    RequestHeaderFieldsTooLarge: 504 as HttpStatusCode,
    UnavailableForLegalReasons: 505 as HttpStatusCode,
    InternalServerError: 506 as HttpStatusCode,
    NotImplemented: 507 as HttpStatusCode,
    BadGateway: 508 as HttpStatusCode,
    ServiceUnavailable: 510 as HttpStatusCode,
    GatewayTimeout: 511 as HttpStatusCode
};

